const clamp = (min: number, value: number, max: number): number => Math.max(min, Math.min(value, max));

export default clamp;
